import { create } from 'zustand';

/**
 * Admin-wide live/test data switch. Sent on every request as
 * `x-admin-data-scope`; ff-api endpoints that list or count tester-flagged rows
 * read it (an explicit `?test=` on a request still wins). Pre-launch nearly
 * everything is tester=1, so `live` is the view that shows real activity.
 */
export type DataScope = 'live' | 'test' | 'all';

export const DATA_SCOPES: { key: DataScope; label: string }[] = [
  { key: 'live', label: 'Live' },
  { key: 'test', label: 'Test' },
  { key: 'all', label: 'All' },
];

const STORAGE_KEY = 'ff-admin:data-scope:v1';

const readLocal = (): DataScope => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return DATA_SCOPES.some((s) => s.key === v) ? (v as DataScope) : 'live';
  } catch {
    return 'live';
  }
};

export const useDataScopeStore = create<{ scope: DataScope; setScope: (s: DataScope) => void }>((set) => ({
  scope: typeof window === 'undefined' ? 'live' : readLocal(),
  setScope: (scope) => {
    try {
      localStorage.setItem(STORAGE_KEY, scope);
    } catch {
      /* private mode */
    }
    set({ scope });
  },
}));
